import includes from 'lodash/includes';
/**
 * toggleInArray - add or remove element from array
 * @param {string} value - the value to be added or removed
 * @param {any} array - the array to mutate
 * @return {array} return new array;
 */
const toggleInArray = (value, array) => {
  const isInArray = includes(array, value);
  return isInArray ? array.filter(i => i !== value) : [...array, value];
};

export default toggleInArray;



// WEBPACK FOOTER //
// ./src/util/toggleInArray.js